import { useMutation } from 'react-apollo'
import { CreatePackage } from '../../../graphql/packages/mutations'

/**
 *  Creates a package (aka orderset)

 * @returns Package
 */

export const useMutationCreatePackageApi = () => {
  const [createPackage, { data: createPackageData, error: createPackageError, loading: createPackageLoading }] = useMutation(CreatePackage, {})

  return [
    createPackage,
    {
      data: createPackageData,
      error: createPackageError,
      loading: createPackageLoading,
    },
  ] as const
}
